// extracted by mini-css-extract-plugin
export var avatarContainer = "_ge-0";
export var avatarTypingWave = "_ge-i";
export var gray = "_ge-f";
export var green = "_ge-c";
export var icon = "_ge-9";
export var image = "_ge-1";
export var lg = "_ge-6";
export var md = "_ge-5";
export var presenceDot = "_ge-b";
export var red = "_ge-d";
export var sm = "_ge-4";
export var status = "_ge-a";
export var typingDot = "_ge-h";
export var typingPill = "_ge-g";
export var xl = "_ge-7";
export var xs = "_ge-3";
export var xxl = "_ge-8";
export var xxs = "_ge-2";
export var yellow = "_ge-e";